import {
  CHANGE_ADD_ESCROW_OPTION,
  CHANGE_STEP,
  CHOOSE_DOCUMENT,
  CHOOSE_DOCUMENT_CANCELLATION,
  CHOOSE_DOCUMENT_FAILURE,
  CHOOSE_DOCUMENT_SUCCESS,
  FETCH_HELOC_DRAW,
  FETCH_HELOC_DRAW_FAILURE,
  FETCH_HELOC_DRAW_SUCCESS,
  FETCH_LOAN,
  FETCH_LOAN_FAILURE,
  FETCH_LOAN_SUCCESS,
  FETCH_MORTGAGE,
  FETCH_MORTGAGE_FAILURE,
  FETCH_MORTGAGE_SUCCESS,
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_FAILURE,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTION_DETAIL,
  FETCH_TRANSACTION_DETAIL_FAILURE,
  FETCH_TRANSACTION_DETAIL_SUCCESS,
  PROCESS_DOCUMENT,
  PROCESS_DOCUMENT_FAILURE,
  PROCESS_DOCUMENT_SUCCESS,
  RESET_ADD_ESCROW_OPTION,
  RESET_BANNER_ERROR,
  RESET_CONFIRMATION,
  RESET_DOCUMENT_STATE,
  RESET_ESCROW_HISTORY_STATE,
  RESET_FORM_ERROR,
  RESET_FORM_ERRORS,
  RESET_FORM_STATE,
  RESET_HELOC_DRAW_FORM_FLOW_STATE,
  RESET_HELOC_DRAW_STATE,
  RESET_REQUEST_STATUS_STATE,
  RESET_STEP_STATE,
  SET_IS_HELOC_DRAW_AVAILABLE,
  SET_SELECTED_MORTGAGE_LOAN,
  SUBMIT_HELOC_DRAW,
  SUBMIT_HELOC_DRAW_FAILURE,
  SUBMIT_HELOC_DRAW_SUCCESS,
  SUBMIT_HELOC_DRAW_VALIDATION_FAILURE,
  UPDATE_FORM_ERROR,
  UPDATE_FORM_VALUE,
  UPDATE_HELOC_DRAW_AMOUNT,
  UPDATE_SELECTED_INSURANCE,
  UPDATE_SELECTED_TRANSACTION,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_FAILURE,
  UPLOAD_DOCUMENT_SUCCESS,
  VALIDATE_ROUTING,
  VALIDATE_ROUTING_FAILURE,
  VALIDATE_ROUTING_SUCCESS,
} from './constants';

export function changeAddEscrowOption(addEscrowOption) {
  return {
    payload: { addEscrowOption },
    type: CHANGE_ADD_ESCROW_OPTION,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function chooseDocument({ isSecondFile, reviewScreenName, type }) {
  return {
    payload: { isSecondFile, reviewScreenName, type },
    type: CHOOSE_DOCUMENT,
  };
}

export function chooseDocumentCancellation() {
  return { type: CHOOSE_DOCUMENT_CANCELLATION };
}

export function chooseDocumentFailure({ bannerError }) {
  return {
    payload: { bannerError },
    type: CHOOSE_DOCUMENT_FAILURE,
  };
}

export function chooseDocumentSuccess() {
  return { type: CHOOSE_DOCUMENT_SUCCESS };
}

export function fetchHelocDraw({ loanNumber }) {
  return {
    payload: { loanNumber },
    type: FETCH_HELOC_DRAW,
  };
}

export function fetchHelocDrawFailure() {
  return { type: FETCH_HELOC_DRAW_FAILURE };
}

export function fetchHelocDrawSuccess({
  allowedOperation,
  allowedRoutingNumbers,
  availableAdvanceAmount,
  canUseAnyRoutingNumber,
  creditLineLimit,
  isAccountRequired,
  minimumAdvanceAmount,
  statusBanner,
}) {
  return {
    payload: {
      allowedOperation,
      allowedRoutingNumbers,
      availableAdvanceAmount,
      canUseAnyRoutingNumber,
      creditLineLimit,
      isAccountRequired,
      minimumAdvanceAmount,
      statusBanner,
    },
    type: FETCH_HELOC_DRAW_SUCCESS,
  };
}

export function fetchLoan(payload) {
  return {
    payload,
    type: FETCH_LOAN,
  };
}

export function fetchLoanFailure(error) {
  return {
    payload: { error },
    type: FETCH_LOAN_FAILURE,
  };
}

export function fetchLoanSuccess(summary) {
  return {
    payload: { summary },
    type: FETCH_LOAN_SUCCESS,
  };
}

export function fetchMortgage({ loanNumber }) {
  return {
    payload: { loanNumber },
    type: FETCH_MORTGAGE,
  };
}

export function fetchMortgageFailure(error) {
  return {
    payload: { error },
    type: FETCH_MORTGAGE_FAILURE,
  };
}

export function fetchMortgageSuccess({ mortgageInfo }) {
  return {
    payload: { mortgageInfo },
    type: FETCH_MORTGAGE_SUCCESS,
  };
}

export function fetchTransactions() {
  return { type: FETCH_TRANSACTIONS };
}

export function fetchTransactionsFailure(error) {
  return {
    payload: { error },
    type: FETCH_TRANSACTIONS_FAILURE,
  };
}

export function fetchTransactionsSuccess(page, totalPages, transactions) {
  return {
    payload: { page, totalPages, transactions },
    type: FETCH_TRANSACTIONS_SUCCESS,
  };
}

export function fetchTransactionDetail(transactionId) {
  return {
    payload: { transactionId },
    type: FETCH_TRANSACTION_DETAIL,
  };
}

export function fetchTransactionDetailFailure(error) {
  return {
    payload: { error },
    type: FETCH_TRANSACTION_DETAIL_FAILURE,
  };
}

export function fetchTransactionDetailSuccess(transaction) {
  return {
    payload: { transaction },
    type: FETCH_TRANSACTION_DETAIL_SUCCESS,
  };
}

export function processDocument({ file, isSecondFile, mobile }) {
  return {
    payload: { file, isSecondFile, mobile },
    type: PROCESS_DOCUMENT,
  };
}

export function processDocumentFailure({
  bannerError,
  file,
  isSecondFile,
  validationError,
} = {}) {
  return {
    payload: {
      bannerError,
      file,
      isSecondFile,
      validationError,
    },
    type: PROCESS_DOCUMENT_FAILURE,
  };
}

export function processDocumentSuccess({ file, isSecondFile }) {
  return {
    payload: { file, isSecondFile },
    type: PROCESS_DOCUMENT_SUCCESS,
  };
}

export function resetAddEscrowOption() {
  return { type: RESET_ADD_ESCROW_OPTION };
}

export function resetBannerError() {
  return { type: RESET_BANNER_ERROR };
}

export function resetConfirmation() {
  return { type: RESET_CONFIRMATION };
}

export function resetDocumentState({ doc }) {
  return {
    payload: { doc },
    type: RESET_DOCUMENT_STATE,
  };
}

export function resetFormError({ field, form }) {
  return {
    payload: { field, form },
    type: RESET_FORM_ERROR,
  };
}

export function resetFormErrors({ form }) {
  return {
    payload: { form },
    type: RESET_FORM_ERRORS,
  };
}

export function resetFormState({ form }) {
  return {
    payload: { form },
    type: RESET_FORM_STATE,
  };
}

export function resetEscrowHistoryState() {
  return { type: RESET_ESCROW_HISTORY_STATE };
}

export function resetHelocDrawFormFlowState() {
  return { type: RESET_HELOC_DRAW_FORM_FLOW_STATE };
}

export function resetHelocDrawState() {
  return { type: RESET_HELOC_DRAW_STATE };
}

export function resetRequestStatusState({ state }) {
  return {
    payload: { state },
    type: RESET_REQUEST_STATUS_STATE,
  };
}

export function resetStepState() {
  return { type: RESET_STEP_STATE };
}

export function setIsHelocDrawAvailable() {
  return { type: SET_IS_HELOC_DRAW_AVAILABLE };
}

export function setSelectedMortgageLoan({ loan }) {
  return {
    payload: { loan },
    type: SET_SELECTED_MORTGAGE_LOAN,
  };
}

export function submitHelocDraw({
  accountNumber,
  accountType,
  amount,
  loanNumber,
  nameOnAccount,
  routingNumber,
}) {
  return {
    payload: {
      accountNumber,
      accountType,
      amount,
      loanNumber,
      nameOnAccount,
      routingNumber,
    },
    type: SUBMIT_HELOC_DRAW,
  };
}

export function submitHelocDrawFailure(error) {
  return {
    payload: { error },
    type: SUBMIT_HELOC_DRAW_FAILURE,
  };
}

export function submitHelocDrawValidationFailure({ field, message }) {
  return {
    payload: { field, message },
    type: SUBMIT_HELOC_DRAW_VALIDATION_FAILURE,
  };
}

export function submitHelocDrawSuccess({
  confirmationNumber,
  requestAmount,
  requestDate,
}) {
  return {
    payload: { confirmationNumber, requestAmount, requestDate },
    type: SUBMIT_HELOC_DRAW_SUCCESS,
  };
}

export function updateFormError({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: UPDATE_FORM_ERROR,
  };
}

export function updateFormValue({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: UPDATE_FORM_VALUE,
  };
}

export function updateHelocDrawAmount({ amount }) {
  return {
    payload: { amount },
    type: UPDATE_HELOC_DRAW_AMOUNT,
  };
}

export function updateSelectedInsurance(selectedType) {
  return {
    payload: { selectedType },
    type: UPDATE_SELECTED_INSURANCE,
  };
}

export function updateSelectedTransaction(id) {
  return {
    payload: { id },
    type: UPDATE_SELECTED_TRANSACTION,
  };
}

export function uploadDocument({
  doc2,
  document,
  documentCategory,
  documentName,
  documentSize,
}) {
  return {
    payload: {
      doc2,
      document,
      documentCategory,
      documentName,
      documentSize,
    },
    type: UPLOAD_DOCUMENT,
  };
}

export function uploadDocumentFailure({ bannerError, isSecondFile, validationError } = {}) {
  return {
    payload: { bannerError, isSecondFile, validationError },
    type: UPLOAD_DOCUMENT_FAILURE,
  };
}

export function uploadDocumentSuccess() {
  return { type: UPLOAD_DOCUMENT_SUCCESS };
}

export function validateRouting(payload) {
  return {
    payload,
    type: VALIDATE_ROUTING,
  };
}

export function validateRoutingFailure() {
  return { type: VALIDATE_ROUTING_FAILURE };
}

export function validateRoutingSuccess(payload) {
  return {
    payload,
    type: VALIDATE_ROUTING_SUCCESS,
  };
}
